
import { MetricEventTypes } from "@/shared/enums";
import { GuideRecord } from "@shared/schemas/guides/guideSchema";

interface GuideConfig {
  guides: GuideRecord[];
}

export const metricGuides: Record<MetricEventTypes, GuideRecord> = {
  [MetricEventTypes.DECISION]: {
      id: 1,
      name: "Decision Making",
      title: "guides.decision_making.title",
      video_id: "807d6de3-7ab0-45d8-8838-e2a1583722f3"
    },
  [MetricEventTypes.SCAN_FREQUENCY]: {
      id: 2,
      name: "Scan Rate",
      title: "guides.scan_rate.title",
      video_id: "9c92fd11-66eb-4f9d-b17f-2a5ad042a402"
    },
  [MetricEventTypes.SCAN_TIMING]: {
      id: 3,
      name: "Scan Timing",
      title: "guides.scan_timing.title",
      video_id: "14fa3ded-ca64-4dea-8d8e-9543729b0ab8"
    },
  [MetricEventTypes.AWARENESS]: {
      id: 4,
      name: "Awareness",
      title: "guides.awareness.title",
      video_id: "e58469b2-de20-4e3e-875b-6306a87bad75"
    },
  [MetricEventTypes.CRITICAL_SCAN]: {
      id: 5,
      name: "Critical Scan",
      title: "guides.critical_scan.title",
      video_id: "33bd4fa7-0364-4da4-af06-ca563d535f5f"
    },
};

export const guidesConfig: GuideConfig = {
  guides: [
    {
      id: 0,
      name: "Passing Basics",
      title: "guides.passing_basics.title",
      video_id: "bea10dd5-067a-447a-b322-576827906682"
    },
    ...Object.values(metricGuides)
  ]
}
